<div
  class="wrapper mt-2 p-3"
  [ngStyle]="{
    border:
      task.status === 'uploaded'
        ? '1px solid var(--tbs-primary-green-1200)'
        : '1px solid var(--tbs-primary-blue-600)'
  }"
>
  <div
    style="
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 16px;
      width: 100%;
    "
  >
    <div [style.width.px]="20">
      @if(task.status === 'created') {
      <tbs-icon icon="calcite:x-circle-16" (click)="onDeleteIconClick()"></tbs-icon>
      } @if(task.status === 'uploaded') {
      <tbs-icon
        icon="calcite:check-circle-16-f"
        [color]="'var(--tbs-primary-green-1200)'"
      ></tbs-icon>
      }
    </div>

    <div [style.width.%]="100">
      <div
        class="folder-name"
        [ngStyle]="{
          color:
            task.status === 'uploaded'
              ? 'var(--tbs-primary-green-1200)'
              : 'var(--tbs-primary-blue-1000)'
        }"
      >
        {{ task.rootFolderName }}
      </div>

      @if (task.status === 'created' || task.status === 'queue') { @if
      (task.status === 'queue') {
      <span>Waiting:</span>
      }
      <span>
        {{ metrics.totalNumberOfFiles }} Files -
        {{ metrics.totalSize | fileSize }}
      </span>
      } @if (task.status === 'uploading') {
      <span>
        {{
          (metrics.uploadedSize / metrics.totalSize) * 100 | number : "1.0-2"
        }}% Complete - {{ timeRemainingMs | timeDuration }} Remaining
      </span>
      <tbs-progress>
        <tbs-progress-bar
          tbsFill="opaque"
          tbsColor="blue"
          [tbsPercent]="(metrics.uploadedSize / metrics.totalSize) * 100"
        ></tbs-progress-bar>
      </tbs-progress>
      } @if (task.status === 'paused') {
      <span>
        Paused - {{ metrics.uploadedNumberOfFiles }} of
        {{ metrics.totalNumberOfFiles }}
      </span>

      @switch (task.dataType) { @case ('map') {
      <span>Mapping Images Uploaded</span>
      } @case ('pano') {
      <span>Panorama Images Uploaded</span>
      } @case ('other') {
      <span>Other Files Uploaded</span>
      } }
      <tbs-progress>
        <tbs-progress-bar
          tbsFill="opaque"
          tbsColor="blue"
          [tbsPercent]="(metrics.uploadedSize / metrics.totalSize) * 100"
        ></tbs-progress-bar>
      </tbs-progress>
      } @if (task.status === 'uploaded') { @switch (task.dataType) { @case
      ('map') {
      <span [style.color]="'var(--tbs-primary-green-1200)'"
        >Uploaded {{ metrics.totalNumberOfFiles }} Mapping Images</span
      >
      } @case ('pano') {
      <span [style.color]="'var(--tbs-primary-green-1200)'"
        >Uploaded {{ metrics.totalNumberOfFiles }} Panorama Images</span
      >
      } @case ('other') {
      <span [style.color]="'var(--tbs-primary-green-1200)'"
        >Uploaded {{ metrics.totalNumberOfFiles }} Other Files</span
      >
      } }
      <tbs-progress>
        <tbs-progress-bar
          tbsFill="opaque"
          tbsColor="green"
          [tbsPercent]="100"
        ></tbs-progress-bar> </tbs-progress
      >}
    </div>
  </div>

  @if(task.status === 'created') {
  <div
    style="
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 16px;
    "
  >
    <div [style.width.px]="154">
      <form tbs-form tbsLayout="vertical">
        <tbs-form-label [tbsRequired]="true">Data Type</tbs-form-label>
        <tbs-form-control>
          <tbs-select
            tbsPlaceHolder="Select Data Type"
            [ngModel]="task.dataType"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onDataTypeChange($event)"
          >
            <tbs-option tbsValue="map" tbsLabel="Mapping Images"></tbs-option>
            <tbs-option tbsValue="pano" tbsLabel="Panoramas"></tbs-option>
            <tbs-option tbsValue="other" tbsLabel="Other"></tbs-option>
          </tbs-select>
        </tbs-form-control>
      </form>
    </div>
    <tbs-icon icon="calcite:information-16" (click)="onInfoIconClick()"></tbs-icon>
  </div>
  }
</div>
